import { doGet, doPost, doPut } from '@/tools/axios'

export default {
  postPackage (data) {
    return doPost('/expresses', data)
  },
  putPackage (data) {
    return doPut(`/expresses/${data.id}`, data)
  },
  getExpressOrders (type, page, perPage) {
    return doGet('/expresses/orders', {
      type,
      page,
      perPage
    })
  },
  getExpressInfo (id) {
    return doGet(`/expresses/${id}`)
  },
  getExpressInfoByUuid (uuid) {
    return doGet(`/expresses/${uuid}/info`)
  },
  setRcvAddress (uuid, data) {
    return doPost(`/expresses/${uuid}/setRcvAddress`, data)
  },
  cancelExpress (id) {
    return doPost(`/expresses/${id}/cancel`)
  },
  getOrderCount () {
    return doGet('/expresses/orderCount')
  }
}
